<template>
    <NavBar v-if="!isMobile()" ></NavBar>
    <NavBarmob v-if="isMobile()"></NavBarmob>
    <header  class="page-header" >
    <div class="container">
    </div>
    </header>
      <!-- <Bannerab></Bannerab> -->
    
    <main>
      <section class="content-section contpadd">
    <div class="container">
     <div class="row justify-content-center"><div class="row"><div class="col-md-12"><h3 class="texh3">REFUND POLICY</h3>


<div class="col-sm-12"><div class="hed" style="color: #dd0b63;">Returns</div><p>To be eligible for a return, there should have been a show cancel or Failure of Ticket generation .</p><div class="hed" style="color: #dd0b63;">Refunds (if applicable)</div><p>Once Refund eligable we will send you an email to notify you that we have refunded your Money. </p><p>If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of 5 to 7 working days. </p><div class="hed" style="color: #dd0b63;">Late or missing refunds (if applicable)</div><p> If you haven’t received a refund yet, first check your bank account again. </p><p>Then contact your credit card company, it may take some time before your refund is officially posted.</p><p>Next contact your bank. There is often some processing time before a refund is posted. .</p><p style="padding-bottom:20px;">If you’ve done all of this and you still have not received your refund yet, please contact us at info@palaxicinemas.com. </p></div>




      </div></div></div></div></section>
      <Footers v-if="!isMobile()"></Footers>
      <Footermob v-if="isMobile()"></Footermob>
    </main>
   
   
  </template>
  
  <script>
  // import Bannerab from "./AboutUsBanner.vue";
  import NavBar from "../UI/NavBar.vue";
  import Footers from "../UI/SiteFooter.vue";
  import NavBarmob from "../UI/NavBarmob.vue";
  import Footermob from "../Indexmobile/IndexFooter.vue";
  export default {
    components:{
      // Bannerab,
      NavBar,
      NavBarmob,
      Footermob,
      Footers
    },
    methods:{
      isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
    },
    mounted:async function(){
      var mastHeight=document.querySelector('.page-header, .slider').clientHeight;
      document.querySelector('main').style.marginTop=mastHeight+"px";
    }
  
  };
  
  </script>
  